var _path, _circle, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16699 12C1.16699 7.91453 1.16699 5.87178 2.4362 4.60258C3.7054 3.33337 5.74815 3.33337 9.83366 3.33337H14.167C18.2525 3.33337 20.2952 3.33337 21.5645 4.60258C22.8337 5.87178 22.8337 7.91453 22.8337 12C22.8337 16.0855 22.8337 18.1283 21.5645 19.3975C20.2952 20.6667 18.2525 20.6667 14.167 20.6667H9.83366C5.74815 20.6667 3.7054 20.6667 2.4362 19.3975C1.16699 18.1283 1.16699 16.0855 1.16699 12Z",
    stroke: "white",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.20866,
    cy: 12,
    r: 3.79167,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20801 8.20837V10.5331C8.20801 11.2436 8.20801 11.5988 8.39427 11.8739C8.58053 12.149 8.91035 12.281 9.56999 12.5448L11.3677 13.2639",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.583 12H15.2497",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.583 8.75H14.1663",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.583 15.25H16.333",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardWhiteIcon);
export default __webpack_public_path__ + "static/media/dashboard_white_icon.402c57b5f575299079fd6975f38fec49.svg";
export { ForwardRef as ReactComponent };